module.exports = __webpack_public_path__ + "img/gktitle.204b66cb.png";